import React from "react";
import axios from "axios";

/**
 * getFeaturedBlogs
 * @param {array} filter
 */
 const getHeaderBlogs = async (type = '') => {
    const headers = {
        'X-CSRF-Token': localStorage.getItem('token')
      }
      if (type !== '') {
        return await axios.get(`/api/getheaderblogs?type=${type}`, headers).then(x => x.data).catch(err => console.log(err))
      }else{
        return await axios.get('/api/getheaderblogs', headers).then(x => x.data).catch(err => console.log(err))
      }
}
/**
 * getFeaturedBlogs
 * @param {array} filter
 */
 const getBlog = async (path, type= '') => {
    const headers = {
        'X-CSRF-Token': localStorage.getItem('token')
      }
      if (type !== '') {
          return await axios.get(`/api/showTitle?path=${path}&type=${type}`, headers).then(x => x.data).catch(err => console.log(err))
      }else{
          return await axios.get(`/api/showTitle?path=${path}`, headers).then(x => x.data).catch(err => console.log(err))
      }
}
/**
 * getFeaturedBlogs
 * @param {array} filter
 */
 const getFeaturedBlogs = async (type= '') => {
    const headers = {
        'X-CSRF-Token': localStorage.getItem('token')
      }
      if (type !== '') {
        return await axios.get(`/api/getfeaturedblogs?type=${type}`, headers).then(x => x.data).catch(err => console.log(err))
      }else{
        return await axios.get('/api/getfeaturedblogs', headers).then(x => x.data).catch(err => console.log(err))
      }
}
/**
 * getAllBlogs
 * @param {array} filter
 */
 const getAllBlogs = async (limit = 10, offset = 0, type= '') => {
    const headers = {
        'X-CSRF-Token': localStorage.getItem('token')
      }
      if (type !== '') {
        return await axios.get(`/api/getallblogs?limit=${limit}&offset=${offset}&type=${type}`, headers).then(x => x.data).catch(err => console.log(err))
      }
    return await axios.get(`/api/getallblogs?limit=${limit}&offset=${offset}`, headers).then(x => x.data).catch(err => console.log(err))
}
/**
 * getFeaturedBlogs
 * @param {array} filter
 */
 const getTopBlogs = async (type = '') => {
    const headers = {
        'X-CSRF-Token': localStorage.getItem('token')
      }
      if (type !== '') {
        return await axios.get(`/api/gettopblogs?type=${type}`, headers).then(x => x.data).catch(err => console.log(err))
      }else{
        return await axios.get('/api/gettopblogs', headers).then(x => x.data).catch(err => console.log(err))
      }
}
/**
 * getBlogs
 * @param {array} filter
 */
const getBlogs = async (limit = 10, offset = 0, type = '') => {
    const headers = {
        'X-CSRF-Token': localStorage.getItem('token')
      }
      if (type !== '') {
        return await axios.get(`/api/getblogs?limit=${limit}&offset=${offset}&type=${type}`, headers).then(x => x.data).catch(err => console.log(err))
      }else{
        return await axios.get(`/api/getblogs?limit=${limit}&offset=${offset}`, headers).then(x => x.data).catch(err => console.log(err))
      }
    
}
/**
 * getTags
 * @param {array} filter
 */
const getTags = async (type= '') => {
    const header = {
        'X-CSRF-Token': localStorage.getItem('token')
      }
      if (type !== '') {
        return await axios.get(`/api/getblogs?type=${type}`, headers).then(x => x.data).catch(err => console.log(err))
      }
      return await axios.get('/api/getblogs', headers).then(x => x.data).catch(err => console.log(err))
    }
/**
 * getCat
 * @param {array} filter
 */
const getCat = async (type= '') => {
    const header = {
        'X-CSRF-Token': localStorage.getItem('token')
      }
      if (type !== '') {
        return await axios.get(`/api/getblogs?type=${type}`, headers).then(x => x.data).catch(err => console.log(err))
      }
      return await axios.get('/api/getblogs', headers).then(x => x.data.data).catch(err => console.log(err))
    }

/**
 * getName
 * @param {array} filter
 */
const getName = async (filter, type= '') => {
    const header = {
        'X-CSRF-Token': localStorage.getItem('token')
      }
      if (type !== '') {
        return await axios.get(`/api/getName?id=${filter.id}&type=${type}`, headers).then(x => x.data).catch(err => console.log(err))
      }
      return await axios.get(`/api/getName?id=${filter.id}`, headers).then(x => x.data).catch(err => console.log(err))
    }

export {
    getBlogs,
    getBlog,
    getTags,
    getCat,
    getName,
    getFeaturedBlogs,
    getHeaderBlogs,
    getAllBlogs,
    getTopBlogs
}
